import {
  SET_SESSION_ID,
  SET_PUSH_ID,
  SET_LANGUAGE,
  SET_IS_CONNECTED,
  FETCH_CONFIG_REQUEST,
  FETCH_CONFIG_SUCCESS,
  FETCH_CONFIG_FAILURE,
} from "./actions.type";
import { ConfigState, ConfigActions } from "./types";

const initialState: ConfigState = {
  isConnected: false,
  sessionId: "",
  pushId: "",
  lang: "vn",
  config: undefined,
  pending: false,
};

export default (state = initialState, action: ConfigActions): ConfigState => {
  switch (action.type) {
    case SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload,
      };
    case SET_PUSH_ID:
      return {
        ...state,
        pushId: action.payload,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        lang: action.payload,
      };
    case SET_IS_CONNECTED:
      return {
        ...state,
        isConnected: action.payload,
      };
    case FETCH_CONFIG_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case FETCH_CONFIG_SUCCESS:
      return {
        ...state,
        config: action.payload,
      };
    case FETCH_CONFIG_FAILURE:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
